__turbopack_context__.v({
  "collapsibleContent": "_6FF0zq_collapsibleContent",
  "details": "_6FF0zq_details",
  "label": "_6FF0zq_label",
  "labelGroup": "_6FF0zq_labelGroup",
  "logo": "_6FF0zq_logo",
  "message": "_6FF0zq_message",
  "radio": "_6FF0zq_radio",
  "row": "_6FF0zq_row",
  "rowHeader": "_6FF0zq_rowHeader",
  "rowHeaderDisabled": "_6FF0zq_rowHeaderDisabled",
  "rows": "_6FF0zq_rows",
  "secondaryLabel": "_6FF0zq_secondaryLabel",
  "slideDown": "_6FF0zq_slideDown",
  "slideUp": "_6FF0zq_slideUp",
});
